import { BasePoiContent } from '@/components/ui/Pois/Poi/BasePoi'
import { useSelector } from '@/stores/hooks'
import { getPoi } from '@/stores/pois'
import type { PopupInfo } from '@/stores/temp'

export function PopupContentPoi({ id }: PopupInfo) {
	const poi = useSelector(state => {
		return getPoi(state, id)
	})

	if (!poi) return null

	return <BasePoiContent poi={poi} />
}
